import React from 'react'

const Copyright = () => {
  return (
    <div className="copyright-parent">
    <div className="copyright-extend" >
      copyright &copy; {new Date().getFullYear()} RICHARD SCHEIWE
    </div>
    </div>
  )
}

export default Copyright



// WEBPACK FOOTER //
// ./src/components/Copyright.js